// Version page for deployment verification
import React from 'react';

const Version: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-md">
        <h1 className="text-2xl font-bold mb-4">Deployment Version</h1>
        <div className="space-y-2">
          <p><strong>Build Time:</strong> {new Date().toISOString()}</p>
          <p><strong>Epoch 26 Bug Fixes:</strong> Deployed August 8, 2025</p>
          <p><strong>Edge Functions:</strong> initializeTrial and create-checkout-session deployed</p>
          <p><strong>Paid User Fix:</strong> billing_status and plan_type now returned</p>
          <p><strong>CORS Fix:</strong> create-checkout-session Edge Function added</p>
          <p><strong>Double Nav:</strong> Fixed with AuthenticatedLayout wrapper</p>
        </div>
      </div>
    </div>
  );
};

export default Version;